import { Form, InputNumber, Spin } from "antd";
import React, { useRef } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ndovu from "../../../assets/img/Main logo.png"; 
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";

function MpesaForm() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { saving } = useSelector((state) => state.save);
  const handleCancel = () => {
    navigate("/commissions");
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/commission/save-withdrawal",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
  return (
    <div>
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className="lg:w-[700px] w-full lg:mt-0 mt-5"
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="cwAmount"
          label="Amount"
          rules={[
            {
              required: true,
              message: "Enter amount",
            },
          ]}
        >
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter amount"
            className="input flex"
          />
        </Form.Item>
        <Form.Item label="Withdraw to">
          <div>
            <img
              src={ndovu}
              loading="lazy"
              alt="ndovu"
              className="w-[100px] h-full"
            />
          </div>
        </Form.Item>
        <Form.Item
          className="table-form-item"
          name="cwMobileNo"
          label="Receiver Number"
          rules={[
            {
              required: true,
              message: "Please add Receiver Number",
            },
            {
              validator: (_, value) => {
                if (value && value.length === 12) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Phone number must be exactly 10 characters")
                );
              },
            },
          ]}
        >
          <PhoneInput
            country="ke"
            countryCodeEditable={false}
            className="input"
          />
        </Form.Item>
        <div className="flex justify-between mt-[60px] mb-[48px] items-center">
          <div className="w-[150px]">
            <button
              disabled={saving}
              key="submit"
              type="submit"
              className="cstm-btn-2"
            >
              {saving ? <Spin /> : "Submit"}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default MpesaForm;
